// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"748":"3d4bcfff","869":"3d4bcfff"}[chunkId] + ".chunk.css";
};